import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsItamsConstants {
    // Labels
    static STEP_TITLE = "Details";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static DESCRIPTION_LABEL = "Description";
    static APPLICATION_TYPE_LABEL = "Application type";
    static TRADING_GOODS_LABEL = "Trading goods";
    static TRADING_GOODS_DESCRIPTION_LABEL = "Trading goods description";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_LABEL = "Previous application reference number";
    static VERIFY_REFERENCE_NUMBER_LABEL = "Verify reference number";
    static REFERENCE_VERIFIED_LABEL = "Reference number verified";
    static REFERENCE_NOT_VERIFIED_LABEL = "Reference number not verified";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static DUPLICATE_ERROR_TRADE_GOODS = "The trading goods option has already been added. Please select a different option ";
    static DUPLICATE_ERROR_DESCRIPTION = "The description has already been used. Please use a different description.";
    static ENTER_REFERENCE_NO = "Please enter a reference number to verify.";
    // Controls
    static TRADING_GOODS_FORM_ARRAY_NAME = "tradeGoods";
    static TRADING_GOODS_CONTROL_NAME = "tradeGoods";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "type";
    static PREVIOUS_APPLICATION_VALIDATED_CONTROL_NAME = "previousApplicationValidated";
    static TRADING_GOODS_DESCRIPTION_FORM_CONTROL_NAME = "tradingGoodsDescription";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_CONTROL_NAME = "previousReferenceNumber";
    static TRADERS_FORM_GROUP_NAME = "tradersForm";
    static TRADERS_FORM_CONTROL_NAME = "traders";
    static CENTROID_FORM_CONTROL_NAME = "centroid";
    static BAYS_FORM_GROUP_NAME = "baysForm";
    static BAYS_FORM_CONTROL_NAME = "bays";
    static ADD_TRADING_GOODS_LABEL = "Add trading goods";
    static REMOVE_TRADING_GOODS_LABEL = "Remove trading goods";
    // LookupNames
    static APPLICATION_TYPE_LOOKUP_NAME = "ApplicationType";
    static TRADING_GOODS_LOOKUP_NAME = "TradingGoods";
    // Validation messages
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, tradingGoods: {
            required: `Trading goods ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, previousApplicationReferenceNumber: {
            required: `Previous application number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }, tradingGoodsDescription: {
            required: `Trading goods description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
